import SubmissionReviewerApi from 'Api/submissionReviewer';

export const SUBMISSION_REVIEWER_LIST_REQUEST = 'SUBMISSION_REVIEWER_LIST_REQUEST';
export const SUBMISSION_REVIEWER_LIST_SUCCESS = 'SUBMISSION_REVIEWER_LIST_SUCCESS';
export const SUBMISSION_REVIEWER_LIST_ERROR = 'SUBMISSION_REVIEWER_LIST_ERROR';
export const SUBMISSION_REVIEWER_LIST_UPDATE_FILTER = 'SUBMISSION_REVIEWER_LIST_UPDATE_FILTER';

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param round
 * @param filter
 * @returns {Object}
 */
export function load(round, filter = {}) {
    return {
        requestType: 'SUBMISSION_REVIEWER_LIST',
        request: SubmissionReviewerApi.find(filter),
        success: (response) => {
            return {
                payload: {
                    round,
                    data: response.data,
                    metadata: {...response}
                },
            };
        },
    };
}


/**
 * Update filter
 *
 * @param {Number} round
 * @param {Object} filter
 *
 * @return {Object}
 */
export function updateFilter(round, filter = {}) {
    return {
        type: SUBMISSION_REVIEWER_LIST_UPDATE_FILTER,
        payload: {round, filter},
    };
}



// WEBPACK FOOTER //
// ./src/actions/submissionReviewer.js